"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAGA_ERROR = void 0;
exports["default"] = sagaError;
var SAGA_ERROR = 'WEB_CHAT/SAGA_ERROR';
exports.SAGA_ERROR = SAGA_ERROR;
function sagaError() {
  return {
    type: SAGA_ERROR
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTQUdBX0VSUk9SIiwiZXhwb3J0cyIsInNhZ2FFcnJvciIsInR5cGUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zYWdhRXJyb3IudHMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0FHQV9FUlJPUiA9ICdXRUJfQ0hBVC9TQUdBX0VSUk9SJztcblxudHlwZSBTYWdhRXJyb3JBY3Rpb24gPSB7XG4gIHR5cGU6IHR5cGVvZiBTQUdBX0VSUk9SO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2FnYUVycm9yKCk6IFNhZ2FFcnJvckFjdGlvbiB7XG4gIHJldHVybiB7IHR5cGU6IFNBR0FfRVJST1IgfTtcbn1cblxuZXhwb3J0IHsgU0FHQV9FUlJPUiB9O1xuXG5leHBvcnQgdHlwZSB7IFNhZ2FFcnJvckFjdGlvbiB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsVUFBVSxHQUFHLHFCQUFxQjtBQUFDQyxPQUFBLENBQUFELFVBQUEsR0FBQUEsVUFBQTtBQU0xQixTQUFTRSxTQUFTQSxDQUFBLEVBQW9CO0VBQ25ELE9BQU87SUFBRUMsSUFBSSxFQUFFSDtFQUFXLENBQUM7QUFDN0IifQ==